import { CSS_COLORS } from 'consts/consts';
import { closeBtn } from 'icons/close';
import './headerOptions.scss';

export const HeaderOptionsTemplate = (model) => {
	const { closeModal, type } = model;

	/* html */
	const html = `
			<div 
				role="button" 
				tabindex="0" 
				class="engt-close engt-tab-selectable" 
				id="engtClose"
				data-wid="${closeModal.wid}"
				data-cid="${closeModal.cid}"
				data-type="${type}"
				onkeydown="ENGT_CHAT.onEnterPress()"
				>
				${closeBtn(CSS_COLORS.THEME_TEXT_COLOR)}
			</div>
    `;

	return html;
};
